import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["type", "name", "onUpdate:modelValue"]
const _hoisted_3 = ["name", "onUpdate:modelValue"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["type", "onUpdate:modelValue"]

import BaseNotecard from "./UI/BaseNotecard.vue";
import { useUserInfo } from "@/store/userInfo";
import { useLangStore } from "@/store/lang";
import { IsSameCity, SalaryType, userInfo } from "@/types/userInfo";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSet',
  setup(__props) {

const userInfoStore = useUserInfo();
const langStore = useLangStore();

const messages = computed(() => {
  return langStore.messages.profileSet;
});

const emptyFields = computed((): userInfo => {
  const empty = JSON.parse(JSON.stringify(userInfoStore.getEmpty));
  if (empty.salaryType)
    empty.salaryType.allowed = langStore.messages.salaryType;
  if (empty.issamecity)
    empty.issamecity.allowed = langStore.messages.isSameCity;
  return empty;
});

const isNumber = (ev: { charCode: number; preventDefault: () => void }) => {
  if (ev.charCode < 48 || ev.charCode > 57) {
    ev.preventDefault();
    return true;
  }
  return true;
};

const setProfileInfo = () => {
  const info = Object.fromEntries(
    Object.entries(emptyFields.value).map(([key, item]) => {
      return [key, item.value];
    })
  );
  console.log(emptyFields.value);

  if (info.salaryType) {
    switch (info.salaryType) {
      case langStore.messages.salaryType.monthly:
        info.salaryType = SalaryType.MONTHLY;
        break;
      case langStore.messages.salaryType.hourly:
        info.salaryType = SalaryType.HOURLY;
        break;
    }
  }

  if (info.issamecity) {
    switch (info.issamecity) {
      case langStore.messages.isSameCity.yes:
        info.issamecity = IsSameCity.YES;
        break;
      case langStore.messages.isSameCity.no:
        info.issamecity = IsSameCity.NO;
    }
  }

  userInfoStore.sendUserData(info);
};

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(BaseNotecard, { class: "profile__notecard" }, {
    default: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(_unref(messages).titleText), 1),
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        class: "profile__form"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(emptyFields), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            class: "profile__item"
          }, [
            _createElementVNode("label", {
              for: item.name
            }, _toDisplayString(item.name), 9, _hoisted_1),
            (item.type === 'string' || item.type === 'date')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: item.type,
                  name: item.name,
                  class: "profile__input",
                  "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                }, null, 8, _hoisted_2)), [
                  [_vModelDynamic, item.value]
                ])
              : (item.type === 'select')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    name: item.name,
                    class: "profile__input",
                    "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.allowed, (value) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: value,
                        value: value,
                        class: "profile__input"
                      }, _toDisplayString(value), 9, _hoisted_4))
                    }), 128))
                  ], 8, _hoisted_3)), [
                    [_vModelSelect, item.value]
                  ])
                : (item.type === 'number')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 2,
                      type: item.type,
                      onKeypress: isNumber,
                      class: "profile__input",
                      "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                    }, null, 40, _hoisted_5)), [
                      [_vModelDynamic, item.value]
                    ])
                  : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createVNode(_component_base_button, {
          class: "profile__button",
          onClick: setProfileInfo
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(messages).saveText), 1)
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }))
}
}

})